import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import ShopPageHeader from './ShopPageHeader';
import ShopPageHeader_shop_header_updates from '../ShopPageHeader.shop_header_updates';

export default withFeatureBranch({
  shop_header_updates: ShopPageHeader_shop_header_updates,
})(ShopPageHeader);
